import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6e76023d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pagination"
};
const _hoisted_2 = {
  class: "row-per-page"
};
const _hoisted_3 = {
  key: 0,
  class: "page-location-string"
};
const _hoisted_4 = {
  class: "pagination-pages"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_button_radio_group = _resolveComponent("app-button-radio-group");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_flex_row, {
    gap: 8,
    class: "per-page"
  }, {
    default: _withCtx(() => [_createVNode(_component_app_button_radio_group, {
      options: $data.perPageOptions,
      modelValue: $options.perPageValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.perPageValue = $event)
    }, null, 8, ["options", "modelValue"]), _createElementVNode("span", _hoisted_2, _toDisplayString($props.isListingView ? 'listings' : $props.isParentView ? 'groups' : 'rows') + " per page", 1)]),
    _: 1
  }), _createVNode(_component_flex_row, {
    gap: 24
  }, {
    default: _withCtx(() => [$props.total > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($options.pageLocationString), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createVNode(_component_app_button, {
      disabled: $props.page == 1,
      version: "page",
      v2: "",
      onClick: $options.onPrev
    }, {
      default: _withCtx(() => [_createVNode(_component_app_icon, {
        icon: "chevron-left2"
      })]),
      _: 1
    }, 8, ["disabled", "onClick"]), _createVNode(_component_app_button, {
      disabled: $props.page == $options.pagesCount,
      version: "page",
      v2: "",
      onClick: $options.onNext
    }, {
      default: _withCtx(() => [_createVNode(_component_app_icon, {
        icon: "chevron-right2"
      })]),
      _: 1
    }, 8, ["disabled", "onClick"])])]),
    _: 1
  })]);
}